import ApiClient from './ApiClient'

export default class IdCheckServices {

  constructor() {
    this.apiClient = new ApiClient()
  }

  get(referenceId) {
    return this.apiClient.create().get(`tutorreferences?id=${referenceId}`)
  }

  getReferences() {
    return this.apiClient.createAuthed().get('tutorreferences')
  }

  addReference(reference) {
    return this.apiClient.createAuthed().post('tutorreferences', reference)
  }

  deleteReference(referenceId) { 
    return this.apiClient.createAuthed().delete(`tutorreferences/delete?id=${referenceId}`)
  }

  submit(hasDeclined, submission) {
    return this.apiClient.create().post('tutorreferences/submit', {
      id: submission.Id,
      hasDeclined,
      name: submission.RefereeName,
      anyYes: Object.values(submission).some(x => x === 'Yes'),
      answers: JSON.stringify(submission),
    })
  }

}